import React from 'react';

export function toAllCaps(event: React.FormEvent<HTMLInputElement>) {
	const {target} = event;
	if (!(target instanceof HTMLInputElement)) {
		return;
	}
	const {selectionStart, selectionEnd} = target;
	Object.assign(target, {value: target.value.toUpperCase()});
	target.setSelectionRange(selectionStart, selectionEnd);
}
